import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import i18n from './i18n'
import App from './App.vue'

// Import global styles
import './assets/main.css'

// Import Echo for real-time updates
import './bootstrap'

// Create Vue app
const app = createApp(App)

// State management
const pinia = createPinia()
app.use(pinia)

// Internationalisatie (Engels standaard, Nederlands ernaast)
app.use(i18n)

// Sessieherstel gebeurt in de router-guard (die er wél op kan wachten);
// hier initialiseren gaf een race met de eerste navigatie.

// Routing
app.use(router)

// Global error handler
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err)
  console.error('Component:', instance)
  console.error('Info:', info)
  
  // In production, send to error tracking service
  if (import.meta.env.PROD) {
    // TODO: Send to error tracking (e.g., Sentry)
  }
}

// Mount app
app.mount('#app')
